import React, { createContext, useContext, useState, useEffect } from 'react';
import firebase from '../../firebase/FirebaseConfig'
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';

const firestore = firebase.firestore();
const UserContext = createContext();

export function useUser() {
    return useContext(UserContext);
}

export function UserProvider({ children }) {

    const [user, setUser] = useState(null);
    const [loginMethod, setLoginMethod] = useState(null);

    const auth = getAuth();
    const [loading, setLoading] = useState(true); // Prevent Log in page

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (userAuth) => {

            if (userAuth) {
                firestore
                    .collection("users")
                    .where("userId", "==", userAuth.uid)
                    .get()
                    .then(async (querySnapshot) => {
                        querySnapshot.forEach((doc) => {
                            const userInfo = {
                                email: doc.data().email,
                                firstName: doc.data().firstName,
                                lastName: doc.data().lastName,
                                userId: doc.data().userId,
                                userIdMalin1: doc.data().userIdMalin1,
                                role: doc.data().role || "user",
                                imageProfile: doc.data().imageProfile || '',
                            };
                            setUser(userInfo);
                            setLoading(false);
                        });
                    })
            } else {
                setUser(null);
                setLoginMethod(null);
                setLoading(false);
            }
        });
        return () => unsubscribe(); // Unsubscribe when the component unmounts
    }, [auth]);

    const logout = async () => {
        try {
            //clear localStorage only localStorage.getItem('device_dashboard_mode') || 'user'
            localStorage.removeItem('device_dashboard_mode')
            await signOut(auth);
            setUser(null); // Clear the user data from context
        } catch (error) {
            console.error('Error signing out:', error);
        }
    };

    if (loading) {
        return null
    }

    return (
        <UserContext.Provider value={{ user, setUser, loginMethod, setLoginMethod, logout, loading }}>
            {children}
        </UserContext.Provider>
    );
}
